import { IconColumnRemove } from '@tabler/icons-react';
import SimpleControl, {
  SimpleControlKind,
} from 'pages/revisions-module/template-editor/editors/template/toolbar/controls/SimpleControl';
import { useRichTextEditorContext } from '@mantine/tiptap';

/**
 * Removes the selected column.
 */
export default function RemoveColumn({ kind }: { kind: SimpleControlKind }) {
  const { editor } = useRichTextEditorContext();

  return (
    <SimpleControl
      kind={kind}
      label="Odstrániť stĺpec"
      icon={<IconColumnRemove />}
      onClick={() => editor.chain().focus().deleteColumn().run()}
    />
  );
}
